var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ error: _vm.hasErrors }},[_vm._t("default"),(_vm.hasErrors)?_c('div',{staticClass:"errors"},_vm._l((_vm.activeErrorMessages),function(error){return _c('div',{key:error,staticClass:"error form-required"},[_vm._v(" "+_vm._s(_vm.$t(`${error}`))+" ")])}),0):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }